import { render, staticRenderFns } from "./ConfirmPayment.vue?vue&type=template&id=4c69ed9f"
import script from "./ConfirmPayment.vue?vue&type=script&lang=js"
export * from "./ConfirmPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports